import { render, staticRenderFns } from "./St21MonthMultipointForm.vue?vue&type=template&id=c1747bde&"
import script from "./St21MonthMultipointForm.vue?vue&type=script&lang=js&"
export * from "./St21MonthMultipointForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports